import { FC } from "react";
import { Modal, ModalProps, Paragraph, Stack, TextLink } from "@contentful/f36-components";
import { ExternalLinkIcon } from "@contentful/f36-icons";

export const GlossaryHelpModal: FC<Pick<ModalProps, "isShown" | "onClose">> = props => {
    return (
        <Modal title="About Linguiny Glossaries" size="large" {...props}>
            <Stack flexDirection="column" alignItems="start" spacing="spacingS">
                <Paragraph>
                    Linguiny allows you to re-use your DeepL glossaries by importing them. Once you
                    have imported your glossary into Linguiny, you can select it in the
                    configuration screen. Once selected, words are automatically corrected into your
                    desired translation.
                </Paragraph>
                <Paragraph>
                    With a <strong>DeepL Pro Advanced</strong> subscription or higher, you can
                    download glossaries from the DeepL website and then upload them here with the{" "}
                    <strong>Import</strong> button. Whenever you update your glossary in DeepL, you
                    can reupload it here in Linguiny via the <strong>Edit</strong> button.
                </Paragraph>
                <Stack flexDirection="column" alignItems="start" spacing="spacingXs">
                    <TextLink
                        href="https://support.deepl.com/hc/articles/360021634540-About-the-glossary"
                        target="_blank"
                        rel="noopener noreferrer"
                        icon={<ExternalLinkIcon />}
                        alignIcon="end">
                        What is a glossary?
                    </TextLink>
                    <TextLink
                        href="https://support.deepl.com/hc/articles/4405563634706-Download-a-glossary"
                        target="_blank"
                        rel="noopener noreferrer"
                        icon={<ExternalLinkIcon />}
                        alignIcon="end">
                        Downloading a glossary
                    </TextLink>
                    <TextLink
                        href="https://www.deepl.com/pro#team"
                        target="_blank"
                        rel="noopener noreferrer"
                        icon={<ExternalLinkIcon />}
                        alignIcon="end">
                        DeepL Pro Advanced
                    </TextLink>
                </Stack>
            </Stack>
        </Modal>
    );
};
